module.exports = __webpack_public_path__ + "img/scope-insurance.e648fe62.png";